import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <path d='M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM12 11C11.45 11 11 10.55 11 10V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V10C13 10.55 12.55 11 12 11ZM13 15H11V13H13V15Z' />
  </>,
  'Message'
)
